import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BudgetService {
  private url = environment.api;
  constructor(
    private http: HttpClient
  ) { }

  getNomenclature(year: number, month: number) {
    return this.http.get(this.url + "api/erp/accounts/budget/nomenclature/" + year + "/" + month);
  }

  getNomenclatureByAccounts() {
    return this.http.get(this.url + "api/erp/accounts/nomenclature");
  }

  saveBudget(year: number, month: number, list: any) {
    return this.http.post(this.url + "api/erp/accounts/budget/" + year + "/" + month, list)
  }

  updateBudget(year: number, month: number, list: any) {
    return this.http.put(this.url + "api/erp/accounts/budget/" + year + "/" + month, list)
  }

  getBudget(year: number, month: number, warehouse: number) {
    return this.http.get(this.url + "api/erp/accounts/budget/" + year + "/" + month + "/" + warehouse);
  }
}